import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { IMAGE_BASE__URL } from '../../core/services/CusHttp';

@Component( {
  selector: 'course-demo',
  templateUrl: './course-demo.component.html',
  styleUrls: [ './course-demo.component.scss' ]
} )
export class CourseDemoComponent implements OnInit {

  @Input() courseData: any = {};
  @Input() singleData: any;
  IMAGE_BASE__URL = IMAGE_BASE__URL;
  constructor(
    private _router: Router
  ) { }

  ngOnInit() {
  }

  //跳转详情页
  gotodetail( id: any ) {
    this._router.navigate( [ '/station/coudetail', id ] );
  }

}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/course-demo/course-demo.component.ts